import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectConfigurations } from '../../selectors';
import { Configurations } from '../../components/Configurations';

export const ConfigurationsContainer = () => {
  const configurations = useSelector(selectConfigurations);

  if (!configurations.length) {
    return null;
  }

  return <Configurations configurations={configurations} />;
};
